import React, {Component} from 'react';
import {Button, Modal, Grid, Form} from 'semantic-ui-react';
import update from 'react-addons-update';

import localDB from "../../data/localDB";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {partialOpenBoxDialog} from "../../actions/PartialOpenBoxDialogActions";
import PartialOpenBoxData from "../../data/PartialOpenBoxData";
import {selectPartialOpenBox} from "../../actions/PartialOpenBoxSelectAction";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const moneyMask = createNumberMask({
    prefix: '$',
});

class PartialOpenBoxDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            partial_open_box: {
                amount: "",
                id: null,
            },
            open_box: props.open_box,
            amount_error: false,
            sending: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.dialog){
            this.setState({partial_open_box:nextProps.dialog.partial_open_box});
        }
    }

    handleAmountChange = (event) => {
        let value = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        let partial_open_box = update(this.state, {
            partial_open_box: {
                amount: {
                    $set: value
                }
            }
        });
        this.setState(partial_open_box);
        if (event.target.value  <= 0 ) {
            this.setState({amount_error: true});
        } else {
            this.setState({amount_error: false});
        }
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.partial_open_box.amount <= 0) {
            this.setState({amount_error: true});
        }else if(this.state.partial_open_box.amount > this.props.dialog.cash){
            this.props.showToast({message: 'El monto es mayor a lo que hay en caja!', type: 'error'});
        } else {
            this.setState({sending: true});
            let data = this.state.partial_open_box
            data['open_box'] = this.state.open_box

            if (data.id) {
                PartialOpenBoxData.put(data, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Cierre de Caja Parcial Actualizado!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    localDB.remove('categories');
                    this.setState({sending: false, open: false});
                });
            } else {
                PartialOpenBoxData.post(data, (res) => {
                    if(res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Cierre de Caja Parcial Agregado!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({sending: false});
                });
            }
        }
    };

    handleClose = () => {
        this.props.partialOpenBoxDialog({open: false, partial_open_box:{id:null, amount:0}});
    };

    dispatchData = (partial_open_box, message) => {
        this.props.selectPartialOpenBox(partial_open_box);
        this.props.partialOpenBoxDialog({open:false, partial_open_box:{id: null, amount: 0}});
        this.props.showToast({message: message, type: 'success'});
    };

    render() {
        return (
            <div>
                <Modal size='tiny' dimmer='inverted' open={this.props.dialog.open} onClose={this.handleClose}>
                    <Modal.Header>{this.props.dialog.partial_open_box.id ? 'Actualizar Cierre Parcial':'Nuevo Cierre Parcial'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Input
                                                label='Valor'
                                                error={this.state.amount_error} type='number'
                                                children={
                                                    <MaskedInput
                                                        mask={moneyMask}
                                                        value={this.state.partial_open_box.amount}
                                                        placeholder='Valor'
                                                        onChange={this.handleAmountChange}
                                                    />
                                                }
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' disabled={this.state.sending} loading={this.state.sending} labelPosition='left' onClick={this.handleSubmit} content={this.props.dialog.partial_open_box.id ? 'Actualizar':'Guardar'} />
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        dialog: state.get('partial_open_box_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        partialOpenBoxDialog(data) {
            dispatch(partialOpenBoxDialog(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectPartialOpenBox(data){
            dispatch(selectPartialOpenBox(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PartialOpenBoxDialog);


// WEBPACK FOOTER //
// ./src/components/sale/PartialOpenBoxDialog.js